<template>
    <div class="overview mainBody">
        <div class="charts">
            <div class="input_group" v-if="groupList.item1.isShow">
                        <label v-if="groupList.item1.selectOrinput" class="input_label" for="select">{{groupList.item1.lable}}</label>
                        <el-select v-if="groupList.item1.selectOrinput" id="select" class="inputInner" v-model="groupList.item1.selectValue" placeholder="请选择">
                            <el-option
                            v-for="item in groupList.item1.selectOptions"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                            </el-option>
                        </el-select>
                        <label v-if="!groupList.item1.selectOrinput" class="input_label" for="input">{{groupList.item1.lable}}</label>
                        <el-input v-if="!groupList.item1.selectOrinput" id="input" class="inputInner" v-model="groupList.item1.inputValue" placeholder="请输入内容"></el-input>
                    </div>
                    <div id="main">
                        <div class="main_head">
                            <h1>整体质量概览</h1>
                        </div>
                        <div class="main_body">
                            <div id="main1">
                
                             </div>
                        </div>
                    </div>
        </div>
        <div class="charts">
            <div class="input_group" v-if="groupList.item2.isShow">
                        <label v-if="groupList.item2.selectOrinput" class="input_label" for="select">{{groupList.item2.lable}}</label>
                        <el-select v-if="groupList.item2.selectOrinput" id="select" @change='selectChange' class="inputInner" v-model="groupList.item2.selectValue" placeholder="请选择">
                            <el-option
                            v-for="item in groupList.item2.selectOptions"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                            </el-option>
                        </el-select>
                    </div>
                    <div id="main">
                        <div class="main_head">
                            <h1>质量事件</h1>
                        </div>
                        <div class="main_body">
                            <div id="main2">
                             </div>
                        </div>
                    </div>
        </div>
    </div>
</template>

<script>
import * as echarts from 'echarts';
import API from '@/api/material';
import moment from 'moment';
export default {
    
    name:'overview',
    data(){
        return{
            groupList:{
                item1:{
                    isShow:true,
                    selectOrinput:true, //1 select 0 input
                    lable:'选择工区',
                    selectOptions:[
                        {
                            value:'',
                            label:''
                        },
                    ],
                    placeHolder:'',
                    selectValue:null,
                    inputValue:null,
                },
                item2:{
                    isShow:true,
                    selectOrinput:true, //1 select 0 input
                    lable:'筛选',
                    selectOptions:[],
                    placeHolder:'',
                    selectValue:null,
                    inputValue:null,
                },
            },
            domChar1:'',
            domChar2:'',
            AllClass:this.$store.state.AllClass,
            datasetSource:[[]],
            datasetSource2:[[]],
            eventModuleId:3,
            TypeObj:[
                    {id:1,detail:'事件一',eventName:'事件一',eventtype_id:'1'},
                    ],
            Allsub:[
                    {id:4,detail:"123",eventtype_id:'1',eventmodule_id:"3"},
                    ],
            dimensions:[],
            source:[],
            reLayNum:[]
        }
    },
    methods:{
        selectChange(item){
            let myChart = echarts.getInstanceByDom(document.getElementById('main2'));
            this.formatChart2Data(this.TypeObj,this.Allsub);
        },
        formatAreaList(lists){
            let tmpList = [];
            let list = lists?lists:[];
            for(var i = 0; i <list.length;i++){
                tmpList.push({
                    value:list[i].id,
                    label:list[i].engineering_region_name,
                })
            }
            return tmpList

        },
        getAll(){
            let param = {
                    action:"getall",
                    eventmodule_id:3
                };
            let param2 ={
                    action:"getall",
                    eventmodule_id:this.eventModuleId
                };
            API.getEngineerRegion(this.$store.state.API_params).then((res)=>{
                this.groupList.item1.selectOptions =this.formatAreaList(res.message.obj);
            }).catch(err=>{
                console.log(err);
            })
            API.getModuleManagement(param2).then((res)=>{
                this.Allsub =res.message.obj;
            }).catch(err=>{
                console.log(err);
            })
            API.getModuleEvents(param).then((res)=>{
                this.TypeObj =res.message.obj;
            }).then(()=>{
                this.formatChart2Data(this.TypeObj,this.Allsub);
            }).then(()=>{
                this.getCharts1();
                this.getCharts2();
            }).catch(err=>{
                console.log(err);
            })
            API.getRelayingList(this.$store.state.API_params).then((res)=>{
                for(let i = 0; i <res.message.obj.length;i++){
                    this.reLayNum.push(this.formattingAndRetreiveSource(this.formattingList2(res.message.obj[i]),new Date().getFullYear()))
                };
            }).catch(err=>{
                console.log(err);
            });
            
        },
        formatChart2Data(TypeObj,Allsub){
            //获取事件类型
            //获取各类型子项
            //根据事件类型创建数组对象
            let data = [];
            Object.values(TypeObj).forEach((item,idx)=>{
                    data.push({
                                value:item.id,
                                sumValue:0,
                                label:item.detail,
                                name:item.eventName,
                                eventtype_id:item.id
                                })
            });
            //eventtypeId筛分数据对象，对应对象的value+1
            Object.values(data).forEach((itemF,idx)=>{
                Object.values(Allsub).forEach((itemS,idx)=>{
                       if(itemF.eventtype_id == itemS.eventtype_id) {
                            itemF.sumValue += 1;
                        };
                });
            });
            this.datasetSource2=  data;
            this.groupList.item2.selectOptions =[{label:'一个月以内',value:0}]
        },
        getCharts1(){
            var app = {};
            let myChart = echarts.getInstanceByDom(document.getElementById('main1'));
            if(!myChart){
                myChart = echarts.init(document.getElementById('main1'))
            }    
            var option;
            option = {
            legend: {selectedMode:false},
            tooltip: {},
            dataset: {
                dimensions: ['title','重铺数','铺排数'],
                source:this.source
            },
            xAxis: { type: 'category' },
            yAxis: {},
            // Declare several bar series, each will be mapped
            // to a column of dataset.source by default.
            series: [{ type: 'bar' }, { type: 'bar' }]
            };
            
            option && myChart.setOption(option);
        },
        getCharts2(){
            let myChart = echarts.getInstanceByDom(document.getElementById('main2'));
            if(!myChart){
                myChart = echarts.init(document.getElementById('main2'))
            }  
            var option;

            option = {
            title: {
                text: '',
                // subtext: '总计:5',
                left: 'center'
            },
            tooltip: {
                trigger: 'item'
            },
            legend: {
                orient: 'vertical',
                left: 'right',
                top:'center'
            },
            series: [
                {
                name: '质量事件',
                type: 'pie',
                radius: '50%',
                legendHoverLink: true,
                labelLine:{
                    show:false
                },
                data:this.datasetSource2,
                emphasis: {
                    itemStyle: {
                    shadowBlur: 10,
                    shadowOffsetX: 0,
                    shadowColor: 'rgba(0, 0, 0, 0.5)'
                    },
                    
                }
                }
            ]
            };
            myChart.on('legendselectchanged', (param)=> { //添加点击事件
               Object.values(param.selected).forEach((item,index)=>{
                });
            });
            myChart.dispatchAction({ type: 'highlight', dataIndex: 0 });
            option && myChart.setOption(option);
        },
        qulityFormat(lists,reLayNum){
            let list = lists?lists:[];
            for(let i = 1;i<list.length;i++){
                let sum = 0;
                for(let j = 1;j<list[i].length;j++){
                    sum += list[i][j]
                }
                this.source.push({
                            title:list[i][0],
                            '铺排数':sum,
                            '重铺数':0,
                        })
                for(let x = 1;x<reLayNum.length;x++){
                    if(list[i][0] == reLayNum[x][0][0]){
                        this.source[i-1][`重铺数`] += reLayNum[x][0][1]
                    }
                }
            }
        },
        getAll2(){
          return  new Promise((resolve,reject)=>{
                API.getMaterial_getall(this.$store.state.API_params).then(res=>{
                        this.AllClass.AllMaterialSubMenu = res.message.obj;
                        resolve(res.message.obj)
                    }).catch(err=>{
                        console.log(err);
                    });
            })
            
        },
        formattingList2(lists){
            let list = lists?lists:[];
            let source=[],arr=[];
                let date = moment(list.resetTime).format('YYYY-MM-DD');
                source.push([moment(date).format('yy'),moment(date).format('MM'),1]);
            return source;
        },
        formattingList(lists){
            let list = lists?lists:[];
            let source=[],arr=[];
            for(var idx = 0;idx< list.length;idx++){
                let date = moment(list[idx].entryTime).format('YYYY-MM-DD');
                source.push([moment(date).format('yy'),moment(date).format('MM'),list[idx].number]);
            };
            return source;
        },
        apiGetsource(param,temp){
           return new Promise((resolve, reject) => {
                    API.getMaterialById(param).then(res=>{
                        resolve(res.message.obj)
                    }).catch((err)=>{console.log(err);})
           })        
        },
        DistinguishedByShipId(lists,boatId){
            let list = lists?lists:{}
            let arr = Object.keys(list)
            for(let i = 1;i <=arr.length;i++){
                for(let j = 0;j <list[`${i}`].length;j++){
                    if(list[`${i}`][`${j}`].boatId != boatId && boatId!=null){
                        list[`${i}`].splice(j,1);
                        j--;
                    }
                }
            }
            return list
        },
        async divideMaterialById(switcher,boatId,datasetSource){
            if(switcher == 0){
                let list = this.$store.state.AllClass.AllMaterialType?this.$store.state.AllClass.AllMaterialType:[];
                let param = this.$store.state.API_params4;
                await this.apiGetsource(param).then(res =>{
                        this.AllClass.chartsSource = this.DistinguishedByShipId(res,boatId);
                        this.AllClass.chartsFormat = []
                        for(var i = 1;i <= list.length;i++){
                            this.AllClass.chartsFormat.push(this.formattingAndRetreiveSource(this.formattingList(this.AllClass.chartsSource[`${i}`]),new Date().getFullYear())); 
                        };
                    });
                    if(this.AllClass.chartsFormat =='[]'){
                        return
                    }else{
                        console.log('this.AllClass.chartsFormat',this.AllClass.chartsFormat);
                            this.summaryChartSource(this.AllClass.chartsFormat,datasetSource);   
                            this.qulityFormat(this.datasetSource,this.reLayNum);
                            this.$nextTick(()=>{
                                this.getCharts1();
                                this.getCharts2();  
                            })
                    }
            }
            
        },
        formattingAndRetreiveSource(source,year){
            let temp=[],temp2=[],tempMonth=[],sum = 0,temp3 = [];
            let counter = 0;
            for(var idx =0; idx < source.length;idx++){
                if(source[idx][0] == year){
                    temp.push(source[idx]);
                }
            };
            for(var i = 0 ;i<temp.length;i++){
                temp2.push(temp[i][1]);
            };
            for(var i = 0 ;i<temp2.length;i++){
                let cunrrent = temp2[i];
                if(tempMonth.indexOf(cunrrent) ==-1 ){
                    tempMonth[counter] = temp2[i];
                    temp3.push([tempMonth[counter],sum]);
                    counter++;
                }
                    for(var x = 0;x <= counter;x++){
                        tempMonth[x] == temp2[i]? temp3[x][1] += parseInt(temp[i][2] ):0;
                        
                    }
            
            };
            return  temp3
        },
        summaryChartSource(lists,datasetSource){
            let list = lists?lists:[]
            let dataSet =[];
            let monthArr =[];
            let counter = 0;
            this[`${datasetSource}`] = [[]];
            for(var i =0; i<list.length;i++){                       // i:unidimensional, j:two-dimension,
                for(var j = 0;j <list[i].length;j++){               //if montheArr dosen't contain a number from j list，  
                    if(monthArr.indexOf(list[i][j][0]) ==-1 ){      //then we push the new number into it.
                        monthArr.push(list[i][j][0]);
                        let tempArr = [list[i][j][0]];
                        for(var y =0; y<list.length;y++){
                            tempArr.push(0);
                        };
                        this[`${datasetSource}`].push(tempArr);
                        counter++;
                    }
                    for(var x = 0;x < counter;x++){                 //according to i, enumerating a number from j list and matching it with monthArr.
                            if(monthArr[x] == list[i][j][0]){       //true:summary the number of type i,false:next one.
                                this[`${datasetSource}`][x+1][i+1] += parseInt(list[i][j][1]);
                            }
                    }
                }     
            }
            //make title for echarts source data
            let typearr = this.$store.state.AllClass.AllMaterialType    
            this[`${datasetSource}`][0].push('材料类型')
            for(var i = 0;i < typearr.length;i++){
                this[`${datasetSource}`][0].push(typearr[i].materialName)
            }
            
        },
    },
    created(){
        this.getAll2().then(res=>{
            if(res != null){
                this.divideMaterialById(0,null,'datasetSource');
            }else{
                this.$message({
                    type:'error',
                    message:'数据交互异常'
                });
            }
            
        })
    },
    mounted(){
        this.getAll();
    },
}
</script>

<style scoped>
#main2{
    margin-top: 0;
    height: 75%;
    width: 100%;
    background-color: var(--subject--input2);
    border-radius: var(--border--radius);
}
.overview{
    width: 100%;
    height: 90%;
    display: flex;
    align-items: center;
    justify-content: space-around;
}
.charts{
    height: 100%;
    width: 40%;
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
}

.input_group{
    height: 20%;
    width: 100%;
}
</style>>


